/* Header: compact state once the top row scrolls away. Loaded with defer from sections/header.liquid. */
(function () {
  var header = document.querySelector('.site-header');
  if (!header) return;
  var last = false, bar = header.querySelector('.utility-bar');
  function onScroll() {
    var stuck = window.scrollY > ((bar && bar.offsetHeight) || 90);
    if (stuck !== last) { last = stuck; header.classList.toggle('is-stuck', stuck); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
